import React from 'react';
import { CheckIcon } from 'lucide-react';
import { INCLUDES_KICKER, systemIncludes } from '../data/unstuckContent';
export function IncludesSection() {
  return <section className="w-full bg-charcoal-950 py-12 sm:py-16" aria-labelledby="includes-title" data-id="element-121" data-mp="2dslup0ylue7t">
      <div className="mx-auto max-w-3xl px-5" data-id="element-122" data-mp="28x6isek5qse1">
        <div className="border border-champagne/25 bg-charcoal-900 px-6 py-8 sm:px-10" data-id="element-123" data-mp="23zernmrc7aaw">
          <h2 id="includes-title" className="font-display text-xl font-semibold uppercase tracking-wide text-ivory-50 sm:text-2xl" data-id="element-124" data-mp="1z1ln0y5omocq">
            Inside the UNSTUCK system:
          </h2>
          <ul className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-125" data-mp="1q1ge2jkubhwg">
            {systemIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-126" data-mp="1l3550b2ddbfa">
                <CheckIcon className="mt-1 h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-127" data-mp="3kf7ty0triy0c" />
                <span className="text-[14px] leading-snug text-ivory-200" data-id="element-128" data-mp="3uh0cf7csqwva">{item}</span>
              </li>)}
          </ul>
          <p className="mt-7 border-t border-charcoal-600 pt-5 font-display text-lg italic text-champagne" data-id="element-129" data-mp="2dr491paf8of">
            {INCLUDES_KICKER}
          </p>
        </div>
      </div>
    </section>;
}